module.exports = __webpack_public_path__ + "static/img2-e89ef8703d9409790d9e59a2e8fd66ea.png";